import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardDeck,
  CardGroup,
  Dropdown,
  NavLink,
} from "react-bootstrap";
import "./cardComponent.scss";
import { Card1, Card2, Card3 } from "../../../asset/json/CardDetail";
import "../../common/tooltip.css";
import { LinkContainer } from "react-router-bootstrap";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import { Link } from "react-router-dom";

export const BeginFreeTrial = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <Dropdown className="" show={data} onClick={opencard}>
        <Dropdown.Toggle className="card-right-button">
          Begin Free Trial
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdownOption trailButton"
          onMouseLeave={closecard}
        >
          <span className="dropdown-menu-arrow"></span>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/gold/9"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item  "
          >
            Brand
          </Dropdown.Item>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/platinum/17"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Agency
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
export const StartFreeTrial = () => {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <Dropdown className="" show={data} onClick={opencard}>
        <Dropdown.Toggle className="card-right-button">
          Start Free Trial
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdownOption StartTrailButton"
          onMouseLeave={closecard}
        >
          <span className="dropdown-menu-arrow"></span>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/gold/9"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item  "
          >
            Brand
          </Dropdown.Item>
          <Dropdown.Item
            href="https://app.cloudsocial.io/accounts/platinum/17"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-card-item"
          >
            Agency
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
export function CardDetails1() {
  return (
    <div Container fluid="true" nav-bg="true" id="calender">
      <div className="uiicard">
        <div className="row">
          <div className="col-10 mx-auto card1">
            <CardDeck>
              <CardGroup className="mt-5">
                {Card1.map(({ title, desc, id }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Slide top>
                        <Card.Title className="card-heading-left">
                          {title}
                        </Card.Title>
                      </Slide>
                      <Fade left>
                        <Card.Text className="desc-left">{desc}</Card.Text>
                      </Fade>
                      <Bounce>
                        <ButtonGroup className="mt-3">
                          {/* <LinkContainer to="/schedule-demo">
                            <Button className="card-left-button">
                              Start Scheduling Today
                            </Button>
                          </LinkContainer> */}

                          <a
                            href="https://calendly.com/cloudsocial-support/csdemo"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              className="card-left-button"
                              style={{
                                borderTopRightRadius: "0px",
                                borderBottomRightRadius: "0px",
                              }}
                            >
                              Start Scheduling Today
                            </Button>
                          </a>

                          <LinkContainer to="">
                            {/* <Button className="card-right-button">
                              Begin Free Trial
                            </Button> */}
                            <BeginFreeTrial />
                          </LinkContainer>
                        </ButtonGroup>
                      </Bounce>
                    </Card.Body>
                  </Card>
                ))}

                {Card1.map(({ img, id, title }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                      marginTop: "4%",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div card-body">
                      <Card.Img
                        //className=" card1-img1 img-fluid img-thumbnail img-responsive"
                        className="img-fluid img-responsive cardsImg"
                        src={img}
                        alt={title}
                        height="100"
                        width="100"
                        loading="lazy"
                      />
                    </Card.Body>
                  </Card>
                ))}
              </CardGroup>
            </CardDeck>
          </div>
        </div>
      </div>

      <div className="uicard">
        <div className="row">
          <div className="col-10 mx-auto card1">
            <CardDeck>
              <CardGroup className="mt-5">
                {Card1.map(({ img, id, title }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                      marginTop: "2%",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Card.Img
                        //className=" card1-img1 img-fluid img-thumbnail img-responsive"
                        className="img-fluid img-responsive cardsImg"
                        src={img}
                        alt={title}
                        height="100"
                        width="100"
                      />
                    </Card.Body>
                  </Card>
                ))}
                {Card1.map(({ title, desc, id }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Card.Title className="card-heading-left">
                        {title}
                      </Card.Title>
                      <Card.Text className="desc-left">{desc}</Card.Text>
                      <ButtonGroup className="">
                        {/* <LinkContainer to="/schedule-demo">
                          <Button className="card-left-button">
                            Start Scheduling Today
                          </Button>
                        </LinkContainer> */}
                        <a
                          href="https://calendly.com/cloudsocial-support/csdemo"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            className="card-left-button"
                            style={{
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                            }}
                          >
                            Start Scheduling Today
                          </Button>
                        </a>
                        <LinkContainer to="">
                          {/* <Button className="card-right-button">
                            Begin Free Trial
                          </Button> */}
                          <BeginFreeTrial />
                        </LinkContainer>
                      </ButtonGroup>
                    </Card.Body>
                  </Card>
                ))}
              </CardGroup>
            </CardDeck>
          </div>
        </div>
      </div>
    </div>
  );
}

export function CardDetails2() {
  return (
    <div Container fluid="true" nav-bg="true" id="analysis">
      <div className="row ">
        <div className="col-10 mx-auto mt-5 card1">
          <CardDeck>
            <CardGroup className="">
              {Card2.map(({ img, id, title }) => (
                <Card
                  style={{
                    background: "transparent ",
                    border: "none",
                    marginTop: "2%",
                  }}
                  key={id}
                >
                  <Card.Body className="card-div">
                    <Card.Img
                      //className=" card1-img1 img-fluid img-thumbnail img-responsive"
                      className="img-fluid img-responsive card-img2 cardsImg"
                      src={img}
                      alt={title}
                      height="100"
                      width="100"
                      loading="lazy"
                    />
                  </Card.Body>
                </Card>
              ))}
              {Card2.map(({ title, desc, id }) => (
                <Card
                  style={{
                    background: "transparent ",
                    border: "none",
                  }}
                  key={id}
                >
                  <Card.Body className="card-div">
                    <Slide top>
                      <Card.Title className="card-heading-right">
                        {title}
                      </Card.Title>
                    </Slide>
                    <Fade right>
                      <Card.Text className="desc-right">{desc}</Card.Text>
                    </Fade>
                    <Bounce>
                      <ButtonGroup
                        className="mt-3"
                        style={{
                          float: "right",
                        }}
                      >
                        {/* <LinkContainer to="/schedule-demo">
                          <Button className="card-left-button">
                            Never Miss a Conversation Again
                          </Button>
                        </LinkContainer> */}

                        <a
                          href="https://calendly.com/cloudsocial-support/csdemo"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            className="card-left-button"
                            style={{
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                            }}
                          >
                            Never Miss a Conversation Again
                          </Button>
                        </a>
                        <LinkContainer to="/pricing">
                          {/* <Button className="card-right-button">
                            Start a Free Trial
                          </Button> */}
                          <StartFreeTrial />
                        </LinkContainer>
                      </ButtonGroup>
                    </Bounce>
                  </Card.Body>
                </Card>
              ))}
            </CardGroup>
          </CardDeck>
        </div>
      </div>
    </div>
  );
}

export function CardDetails3() {
  return (
    <div Container fluid="true" nav-bg="true" className="card3" id="dashboard">
      <div className="uiicard">
        <div className="row">
          <div className="col-10 mx-auto mt-5 card1">
            <CardDeck>
              <CardGroup className="">
                {Card3.map(({ title, desc, id }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Slide top>
                        <Card.Title className="card-heading-left">
                          {title}
                        </Card.Title>
                      </Slide>
                      <Fade left>
                        <Card.Text className="desc-left">{desc}</Card.Text>
                      </Fade>
                      <Bounce>
                        <ButtonGroup className="mt-3">
                          {/* <LinkContainer to="/schedule-demo">
                            <Button className="card-left-button">
                              Get Insights Now
                            </Button>
                          </LinkContainer> */}

                          <a
                            href="https://calendly.com/cloudsocial-support/csdemo"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              className="card-left-button"
                              style={{
                                borderTopRightRadius: "0px",
                                borderBottomRightRadius: "0px",
                              }}
                            >
                              Get Insights Now
                            </Button>
                          </a>
                          <LinkContainer to="">
                            {/* <Button className="card-right-button">
                              Start Free Trial
                            </Button> */}
                            <StartFreeTrial />
                          </LinkContainer>
                        </ButtonGroup>
                      </Bounce>
                    </Card.Body>
                  </Card>
                ))}

                {Card3.map(({ img, id, title }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                      marginTop: "2%",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Card.Img
                        //className=" card1-img1 img-fluid img-thumbnail img-responsive"
                        className="img-fluid img-responsive cardsImg"
                        src={img}
                        alt={title}
                        height="100"
                        width="100"
                        loading="lazy"
                      />
                    </Card.Body>
                  </Card>
                ))}
              </CardGroup>
            </CardDeck>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="uicard">
          <div className="col-10 mx-auto mt-5 card1">
            <CardDeck>
              <CardGroup className="">
                {Card3.map(({ img, id, title }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                      marginTop: "2%",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Card.Img
                        //className=" card1-img1 img-fluid img-thumbnail img-responsive"
                        className="img-fluid img-responsive cardsImg"
                        src={img}
                        alt={title}
                        height="100"
                        width="100"
                      />
                    </Card.Body>
                  </Card>
                ))}
                {Card3.map(({ title, desc, id }) => (
                  <Card
                    style={{
                      background: "transparent ",
                      border: "none",
                    }}
                    key={id}
                  >
                    <Card.Body className="card-div">
                      <Card.Title className="card-heading-left">
                        {title}
                      </Card.Title>
                      <Card.Text className="desc-left">{desc}</Card.Text>
                      <ButtonGroup className="">
                        {/* <LinkContainer to="/schedule-demo">
                          <Button className="card-left-button">
                            Get Insights Now
                          </Button>
                        </LinkContainer> */}
                        <a
                          href="https://calendly.com/cloudsocial-support/csdemo"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            className="card-left-button"
                            style={{
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                            }}
                          >
                            Get Insights Now
                          </Button>
                        </a>
                        <LinkContainer to="">
                          {/* <Button className="card-right-button">
                            Start Free Trial
                          </Button> */}
                          <StartFreeTrial />
                        </LinkContainer>
                      </ButtonGroup>
                    </Card.Body>
                  </Card>
                ))}
              </CardGroup>
            </CardDeck>
          </div>
        </div>
      </div>
    </div>
  );
}
